export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

interface DaysWithUniqueFormat {
  '1': string;
  '2': string;
  '3': string;
  [key: string]: string; // Index signature
}

const daysWithUniqueFormat: DaysWithUniqueFormat = {
  '1': 'st',
  '2': 'nd',
  '3': 'rd'
};

export const weekDays: string[] = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

export default function formatDateAndMonth(
  date: string,
  truncateDay = true,
  truncateMonth = true,
  ordinalDay = true
): string {
  const dateFromString = new Date(date);
  const month = truncateMonth
    ? months[dateFromString.getMonth()].slice(0, 3)
    : months[dateFromString.getMonth()];
  const weekDay = truncateDay
    ? weekDays[dateFromString.getDay()].slice(0, 3)
    : weekDays[dateFromString.getDay()];
  const day = dateFromString.getDate().toString();
  const dayLength = day.length;
  const requiresSpecialFormatting =
    Object.keys(daysWithUniqueFormat).includes(day[dayLength - 1]) &&
    (dayLength === 1 || (dayLength === 2 && day[0] !== '1'));
  const formattedDay = requiresSpecialFormatting
    ? day + daysWithUniqueFormat[day[dayLength - 1]]
    : `${day}th`;

  return `${weekDay}, ${month} ${ordinalDay ? formattedDay : day}`;
}
